import React, { useState, useEffect } from 'react';
import { TOOLS } from '../data/Mockdata';

export const ToolsScroller = () => {
    const [activeIndex, setActiveIndex] = useState(4);
    const [toolIndex, setToolIndex] = useState(0);
    const [visibleItems, setVisibleItems] = useState(6);

    useEffect(() => {
        const updateVisibleItems = () => {
            let count = 6;
            if (window.innerWidth < 576) count = 2;
            else if (window.innerWidth < 768) count = 3;
            else if (window.innerWidth < 992) count = 4;
            else if (window.innerWidth < 1200) count = 5;
            
            setVisibleItems(count);
            // Ensure toolIndex doesn't exceed new max
            setToolIndex((prev) => Math.min(prev, Math.max(0, TOOLS.length - count)));
        };

        updateVisibleItems();
        window.addEventListener('resize', updateVisibleItems);
        return () => window.removeEventListener('resize', updateVisibleItems);
    }, []);

    const maxToolIndex = Math.max(0, TOOLS.length - visibleItems);

    return (
        <div>
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                <div className="main-heading mb-0">Popular tools</div>
                <div className="d-flex gap-2">
                    <button
                        className="btn btn-outline-primary btn-sm rounded-circle d-flex align-items-center justify-content-center p-0"
                        style={{ width: "32px", height: "32px" }}
                        onClick={() => setToolIndex((i) => Math.max(0, i - 1))}
                        disabled={toolIndex === 0}
                    >
                        <i className="bi bi-chevron-left lh-1"></i>
                    </button>
                    <button
                        className="btn btn-outline-primary btn-sm rounded-circle d-flex align-items-center justify-content-center p-0"
                        style={{ width: "32px", height: "32px" }}
                        onClick={() => setToolIndex((i) => Math.min(maxToolIndex, i + 1))}
                        disabled={toolIndex >= maxToolIndex}
                    >
                        <i className="bi bi-chevron-right lh-1"></i>
                    </button>
                </div>
            </div>
            <div className="overflow-hidden">
                <div className="d-flex gap-3"
                    style={{
                        transform: `translateX(calc(-${toolIndex} * (155px + 16px)))`,
                        transition: "transform 0.35s ease",
                    }}
                >
                    {TOOLS.map((tool, i) => (
                        <div
                            key={tool.id}
                            className={`border flex-shrink-0 pointer text-center p-3 ${activeIndex === i ? "border-primary" : "border-secondary-subtle"}`}
                            style={{ width: "155px" }}
                            onClick={() => setActiveIndex(i)}
                        >
                            <div className={`tools-name fw-semibold lh-sm mb-1 ${activeIndex === i ? "text-primary" : ""}`}>
                                {tool.name}
                            </div>
                            <p className="tool-courses small text-secondary text-opacity-75 mb-0">{tool.courses}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}